<div *ngIf="items">

    <div class="card mb-2" *ngFor="let item of items">
        <div class="card-body">
            <h5 class="card-title custom-faq-questions-title">{{ item.title }}</h5>
            <p class="card-text lh-base" [innerHTML]="item.text"></p>
      </div>

</div>
